import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { 
    AgentFeedbackRequest,
  FeedbackRequest, 
  FeedbackResponse, 
  FeedbackSearchCriteria 
} from '../../_models/feedback.model';
import { ApiResponse } from '../../_models/api-response.model';

@Injectable({
  providedIn: 'root'
})
export class FeedbackService {
  private apiUrl = `${environment.apiUrl}/feedback`;

  constructor(private http: HttpClient) { }

  submitFeedback(reservationId: number, feedback: FeedbackRequest): Observable<ApiResponse<FeedbackResponse>> {
    return this.http.post<ApiResponse<FeedbackResponse>>(
      `${this.apiUrl}/reservation/${reservationId}`,
      feedback
    );
  }

  getFeedback(reservationId: number): Observable<ApiResponse<FeedbackResponse>> {
    return this.http.get<ApiResponse<FeedbackResponse>>(
      `${this.apiUrl}/reservation/${reservationId}`
    );
  }

  getMyFeedbacks(): Observable<ApiResponse<FeedbackResponse[]>> {
    return this.http.get<ApiResponse<FeedbackResponse[]>>(
      `${this.apiUrl}`
    );
  }

  updateFeedback(reservationId: number, feedback: FeedbackRequest): Observable<ApiResponse<FeedbackResponse>> {
    return this.submitFeedback(reservationId, feedback);
  }

  updateAgentFeedback(reservationId: number, agentId: number, agentFeedback: AgentFeedbackRequest): Observable<ApiResponse<FeedbackResponse>> {
    return new Observable(observer => {
      this.getFeedback(reservationId).subscribe({
        next: (response) => {
          if (response.success && response.data) {
            const existingFeedback = response.data;
            
            const updatedAgentFeedbacks = existingFeedback.agentFeedbacks.map(fb => 
              fb.agentId === agentId 
                ? { ...agentFeedback, agentId, id: fb.id }
                : {
                    agentId: fb.agentId,
                    professionalismRating: fb.professionalismRating,
                    attitudeRating: fb.attitudeRating,
                    efficiencyRating: fb.efficiencyRating,
                    comment: fb.comment || ''
                  }
            );

            const updatedFeedback: FeedbackRequest = {
              overallRating: existingFeedback.overallRating,
              serviceQualityRating: existingFeedback.serviceQualityRating,
              punctualityRating: existingFeedback.punctualityRating,
              communicationRating: existingFeedback.communicationRating,
              comment: existingFeedback.comment || '',
              agentFeedbacks: updatedAgentFeedbacks
            };

            this.submitFeedback(reservationId, updatedFeedback).subscribe(observer);
          } else {
            observer.error(new Error('Feedback not found'));
          }
        },
        error: (err) => observer.error(err)
      });
    });
  }
}